import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const MediaIcon = {
  name: 'MediaIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-media"
    }, ctx.data]), [
      h("g", {
        attrs: {
          opacity: "0.7"
        }
      }, [
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M17.0201 9.91042L13.3528 14.6435L10.1547 12.1312L7.35375 15.7716L6.16492 14.8569L9.88976 10.0157L13.092 12.5311L15.8344 8.9917L17.0201 9.91042Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M19.168 3.75C18.5872 3.75 18.1163 4.22087 18.1163 4.80171C18.1163 5.38256 18.5872 5.85343 19.168 5.85343C19.7489 5.85343 20.2198 5.38256 20.2198 4.80171C20.2198 4.22087 19.7489 3.75 19.168 3.75ZM16.6163 4.80171C16.6163 3.39244 17.7588 2.25 19.168 2.25C20.5773 2.25 21.7198 3.39244 21.7198 4.80171C21.7198 6.21099 20.5773 7.35343 19.168 7.35343C17.7588 7.35343 16.6163 6.21099 16.6163 4.80171Z",
            fill: "currentColor"
          }
        }),
        h("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M2.28027 3.03931H15.1654V4.53931H3.78027V20.25H19.4909V8.83911H20.9909V21.75H2.28027V3.03931Z",
            fill: "currentColor"
          }
        })
      ])
    ]);
  }
};

export default MediaIcon; 